import { PERM } from '#/config/permissions';
import { ROUTES } from '#/config/routes';

/**
 * 物料管理 hub 導覽卡 — 對齊 v1 materialNavigate。
 * 規格、模板、結構、製造商與物料列表共用 ims.mtr.read。
 */
const materialMgmtNavigate = [
  {
    to: ROUTES.mtr,
    title: '物料列表',
    subtitle: '查詢與管理物料主檔',
    permission: PERM.MTR_READ,
  },
  {
    to: ROUTES.mtrSpec,
    title: '規格設定',
    subtitle: '設定物料的相關參數',
    permission: PERM.MTR_READ,
  },
  {
    to: ROUTES.mtrTemplate,
    title: '物料模板',
    subtitle: '設定物料模板，以便快速建立物料',
    permission: PERM.MTR_READ,
  },
  {
    to: ROUTES.mtrStruct,
    title: '物料結構',
    subtitle: '建立物料結構',
    permission: PERM.MTR_READ,
  },
  {
    to: ROUTES.manufacturer,
    title: '製造商列表',
    subtitle: '管理製造商的相關資訊',
    permission: PERM.MTR_READ,
  },
  {
    to: ROUTES.inspectionKind,
    title: '檢測種類',
    subtitle: '設定內部檢測種類與條件版本',
    permission: PERM.INSPECTION_KIND_READ,
  },
  {
    to: ROUTES.materialSn,
    title: '序號檢測履歷',
    subtitle: '查詢序號、首次登錄、重測與作廢',
    permission: PERM.INSPECTION_KIND_READ,
  },
];

export default materialMgmtNavigate;
